const FIRST = {
  id: "7306E1AD-745F-4BEE-829C-71BB380ED61B",
  name: "text_input_06108B97-D7AC-42A5-8167-ECB948331A10",
};
const LAST = {
  id: "99267192-0200-403C-813D-8AF374FE25D0",
  name: "text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143",
};
const BIRTH = {
  id: "8A37D6EF-A9C1-4561-A16C-991E40512778",
  name: "date_picker_ADA9781E-794B-47F3-BB10-87CD39F5A342",
};

const fieldName = (field) => field?.field_name || field?.custom_name || field?.name || "";
const answerName = (item) => item?.custom_name || item?.name || "";

// Fill first name, last name, and birth date from a family member onto whatever
// fields this class form actually has. The preschool template uses BIRTH.name.
// Aftercare's default form uses a different birth-date field.
// ponytail: a form with one date field and no "birth" label is treated as the
// birthday. A second unlabeled date stays empty.
export function memberAnswers(member, formFields, existingAnswers, birthValue) {
  const known = [
    { ...FIRST, custom_name: FIRST.name, value: member?.first_name || "" },
    { ...LAST, custom_name: LAST.name, value: member?.last_name || "" },
    { ...BIRTH, custom_name: BIRTH.name, value: birthValue || "" },
  ];
  const fields = formFields || [];
  const otherBirth = fields.filter((field) => {
    const name = fieldName(field);
    if (!name || name === BIRTH.name) return false;
    const label = (field.label || "").toLowerCase();
    return label.includes("birth") || label.includes("dob");
  });
  const otherDates = fields.filter(
    (field) => field?.element === "DatePicker" && fieldName(field) && fieldName(field) !== BIRTH.name
  );
  const formHasKnownBirth = fields.some((field) => fieldName(field) === BIRTH.name);
  const targets = otherBirth.length
    ? otherBirth
    : !formHasKnownBirth && otherDates.length === 1
      ? otherDates
      : [];
  const familyInfo = [
    ...known,
    ...targets.map((field) => ({
      id: field.id,
      name: fieldName(field),
      custom_name: fieldName(field),
      value: birthValue || "",
    })),
  ];
  const existing = existingAnswers || [];
  const matches = (item, entry) =>
    answerName(item) === entry.name || (item?.id && item.id === entry.id);
  return [
    ...existing.map((item) => {
      const hit = familyInfo.find((entry) => matches(item, entry));
      return hit ? { ...item, value: hit.value } : item;
    }),
    ...familyInfo.filter((entry) => !existing.some((item) => matches(item, entry))),
  ];
}
